import { Component, HostListener } from '@angular/core';
import { RouterOutlet } from '@angular/router';
// import { MatTableModule } from '@angular/material/table';

/**
 * Root application component.
 * Handles global layout adjustments and bootstraps the Angular app.
 */
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  /** Application title */
  protected title = 'digimet-frontend';

  /**
   * Angular lifecycle hook.
   * Sets the initial body height on component initialization.
   */
  ngOnInit() {
    this.updateBodyHeight();
  }

  /**
   * HostListener for window resize events.
   * Updates the body height dynamically when the window is resized.
   */
  @HostListener('window:resize')
  onResize() {
    this.updateBodyHeight();
  }

  /**
   * Updates the document body height to match the viewport height.
   * Ensures the layout fills the visible window.
   * 
   * @private
   */
  private updateBodyHeight() {
    // Set body height based on the visible viewport
    document.body.style.height = `${window.innerHeight}px`;
  }
}